<template>
  <div id="app">
    <audioAuto />
    <router-view />
    <!-- 全局通知窗口 -->
    <NoticeMark />
  </div>
</template>

<script>
import audioAuto from '@/components/audioAuto.vue';
import sseManager from '@/utils/sseManager';
export default {
  components: { audioAuto },
  data() {
    return {
      updateInfo: [
        {
          date: '2026-06-02',
          repair: ['最新服务端下载地址：https://xoaoss001.yyaiya.com/apk/pdServer-dev-5.5.3-new.zip','icebreakers数据加载优化','优化虚拟礼物展示'],
        },
        {
          date: '2025-12-02',
          repair: ['最新服务端下载地址：http://xoss.ireji.com/appdistribution/202512021832_pdServer.zip','优化了消息响应，发件箱的已读消息推送'],
        },
        {
          date: '2025-11-19',
          repair: ['修复媒体库管理页面加载数据失败的问题'],
          added: ['新增媒体库管理页面'],
        },
        {
          date: '2025-11-14',
          repair: [,'修复从其他页面进入缓存页面时，如果之前页面缓存过，没加载数据出现问题的原因'],
        },
        {
          date: '2025-11-12',
          repair: ['最新服务端下载地址：http://oss.chunyunying.com/appdistribution/202511121522_pdServer.zip','优化账号数据统计页面','优化账号调整后，页面的展示效果'],
        },
      {
          date: '2025-11-10',
          repair: ['最新服务端下载地址：http://oss.chunyunying.com/appdistribution/202511100947_pdServer.zip',
          '修复用户读取邮件的新消息通知，点击会消失的问题','创建消息和邮件时，没有添加语气词禁止创建','优化群发创建提示'],
          added: ['新增用户信息数据统计','新增翻译'],
        },{
          date: '2025-11-03',
          repair: ['最新服务端下载地址：http://oss.chunyunying.com/appdistribution/202511031701_pdServer.zip',
          '修复邮件发送之后，图片未读显示的是已读','优化礼物通知改造','修复评论朋友圈，消息不提示'],
          added: ['新增Pd的职业需要展示，统计页面展示的职业信息','新增点赞-在线筛选'],
        }, {
          date: '2025-10-24',
          repair: ['最新服务端下载地址：http://oss.chunyunying.com/appdistribution/202510241634_pdServer.zip'],
          added: ['重构消息通知内容','修改职业展示逻辑','添加点赞消息的筛选功能'],
        },
      {
          date: '2025-10-17',
          repair: ['修复posts发送时媒体库权限问题'],
          added: [],
        },
      {
          date: '2025-10-16',
          repair: ['最新服务端下载地址：http://oss.chunyunying.com/appdistribution/202510161631_pdServer.zip'],
          added: ['新增posts发送条件判断','新增群发消息前缀设置与表情','新增登录页面服务端版本校验'],
        },
        {
          date: '2025-10-13',
          repair: ['修复了回复消息后，消息未删除、错删除的问题'],
          added: [],
          note: ['*已获得财神祝福，财源广进，步步高升!'],
        },
        {
          date: '2025-10-9',
          repair: ['修复首次登录无法获取账户信息的问题'],
          added: [],
        },
        {
          date: '2025-9-26',
          repair: ['优化消息发送判断逻辑'],
        },
        {
          date: '2025-9-25',
          repair: ['阅读邮件信息回退为点击消息后移除'],
          added: ['图片预览支持预览高清原图'],
        },
        {
          date: '2025-9-24',
          repair: [
            '发送消息后更新礼物限制状态',
            '移除阅读邮件信息改为回复消息后移除',
          ],
          added: [],
        },
        {
          date: '2025-9-20',
          repair: [],
          added: ['icebreakers中带有图片的支持预览'],
        },
        {
          date: '2025-9-19',
          repair: [],
          added: ['替换了新的备注图标'],
        },
        {
          date: '2025-9-18',
          repair: ['修复消息列表不显示邮件消息的问题'],
          added: ['icebreakers创建时可添加图片'],
        },
        {
          date: '2025-9-17',
          repair: [],
          added: ['新增更新公告', '新增礼物提示消息', '新增阅读邮件提示消息'],
        },
        // 可以继续添加更多版本，例如：
        // {
        //   date: '2025-7-1',
        //   repair: [
        //     '修复消息发送失败的问题',
        //     '优化界面响应速度'
        //   ],
        //   added: [
        //     '新增主题切换功能',
        //     '支持消息撤回功能'
        //   ]
        // }
      ],
    };
  },
  mounted() {
    // 移除自动调用getVersion，改为登录后手动调用
    // 将更新通知方法挂载到全局，供其他组件调用
    this.$root.checkUpdateNotice = this.checkAndShowUpdateNotice;
  },
  methods: {
    // 检查并显示版本更新通知（供其他组件调用）
    checkAndShowUpdateNotice() {
      this.getVersion();
    },
    getVersion() {
      // 这边是一个获取线上版本号的接口
      // 获取当前最新版本号（取updateInfo数组中的第一个版本）
      const currentVersion =
        this.updateInfo.length > 0 ? this.updateInfo[0].date : null;
      // 获取本地存储的版本号
      const localVersion = localStorage.getItem('version');

      // 如果当前版本号与本地版本号不一致，或本地没有版本号，则弹出更新通知
      if (currentVersion && currentVersion !== localVersion) {
        this.$showUpdateNotice({
          title: '版本更新公告',
          content: this.generateUpdateContent(),
          confirmText: '本次更新不再提醒',
          onConfirm: () => {
            console.log('不再弹出当前版本');
            // 点击"不再弹出"按钮时，存储当前版本号，本版本不再弹出
            localStorage.setItem('version', currentVersion);
          },
          onClose: () => {
            console.log('关闭');
            // 通过其他方式关闭时，不设置版本号，下次还会继续弹出
          },
        });
      }
      // this.$showMaintenanceNotice({
      //   title: '系统维护通知',
      //   content: `
      //     <div style="text-align: center;">
      //       <h3>⚠️ 系统正在维护中</h3>
      //       <p>维护时间：2024-01-20 02:00 - 04:00</p>
      //       <p>维护期间服务暂不可用，给您带来的不便敬请谅解。</p>
      //       <p>预计维护完成时间：04:00</p>
      //     </div>
      //   `,
      //   showFooter: false // 维护通知可以不显示底部按钮
      // })
    },
    // 生成更新内容HTML
    generateUpdateContent() {
      let contentHtml = `
        <div class="update-content-wrapper" style="max-height: 400px; overflow-y: auto; padding-right: 8px;">
      `;

      // 循环生成每个版本的更新内容
      this.updateInfo.forEach((update, index) => {
        contentHtml += `
          <div class="update-item" style="margin-bottom: ${index < this.updateInfo.length - 1 ? '24px' : '0'
          };">
            <div style="font-size: 22px; font-weight: 600; color: #2c3e50; margin-bottom: 14px;">
              ${update.date}
            </div>
        `;

        // 问题修复部分
        if (update.repair && update.repair.length > 0) {
          contentHtml += `
            <div style="margin-bottom: 16px;">
              <div style="font-size: 16px; font-weight: 500; color: #e74c3c; margin-bottom: 8px; display: flex; align-items: center;">
                <span style="display: inline-block; width: 6px; height: 6px; background-color: #e74c3c; border-radius: 50%; margin-right: 8px;"></span>
                问题修复：
              </div>
              <ul style="margin: 0; padding-left: 20px; color: #5d6d7e;">
          `;
          update.repair.forEach((item, idx) => {
            // 处理长URL，添加换行和样式
            const processedItem = item.replace(/(https?:\/\/[^\s]+)/g, '<span style="word-break: break-all; word-wrap: break-word; display: inline-block; max-width: 100%;">$1</span>');
            contentHtml += `<li style="margin-bottom: 4px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word;">${idx + 1
              }.${processedItem}</li>`;
          });
          contentHtml += `</ul></div>`;
        }

        // 新增内容部分
        if (update.added && update.added.length > 0) {
          contentHtml += `
            <div style="margin-bottom: 16px;">
              <div style="font-size: 16px; font-weight: 500; color: #27ae60; margin-bottom: 8px; display: flex; align-items: center;">
                <span style="display: inline-block; width: 6px; height: 6px; background-color: #27ae60; border-radius: 50%; margin-right: 8px;"></span>
                新增内容：
              </div>
              <ul style="margin: 0; padding-left: 20px; color: #5d6d7e;">
          `;
          update.added.forEach((item, idx) => {
            contentHtml += `<li style="margin-bottom: 4px; line-height: 1.5;">${idx + 1
              }.${item}</li>`;
          });
          contentHtml += `</ul></div>`;
        }

        // 提示信息部分（无标题、斜体小字）
        if (update.note && update.note.length > 0) {
          contentHtml += `
            <div style="margin-bottom: 16px;margin-left: 20px;">
          `;
          update.note.forEach((item) => {
            contentHtml += `<div style="font-size: 12px; font-style: italic; color: #95a5a6; line-height: 1.6; margin-bottom: 6px;">${item}</div>`;
          });
          contentHtml += `</div>`;
        }

        contentHtml += `</div>`;
      });

      contentHtml += `
        </div>
        <style>
          .update-content-wrapper::-webkit-scrollbar {
            width: 6px;
          }
          .update-content-wrapper::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          .update-content-wrapper::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
          }
          .update-content-wrapper::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        </style>
      `;

      return contentHtml;
    },
    // 初始化SSE连接
    initSSE() {
      // 延迟初始化，确保用户已登录
      this.$nextTick(() => {
        setTimeout(() => {
          sseManager.init();
        }, 1000);
      });
    },
  },

  created() {
    // 在应用创建时初始化SSE连接
    this.initSSE();
    // 移除应用启动时的WebSocket初始化，改为在登录成功后或路由守卫中初始化
    // this.initGlobalWebSocket();
  },
  beforeDestroy() {
    // 在应用销毁前断开SSE连接
    sseManager.disconnect();
    // 移除WebSocket断开逻辑，由路由守卫和登录逻辑控制
    // globalWebSocketManager.disconnect();
  },
};
</script>

<style lang="scss">
::v-deep .el-tooltip__popper,
::v-deep .el-tooltip__popper.is-light {
  max-width: 190px !important;
  border-color: none !important;
  background: none !important;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.12), 0 6px 9px rgba(0, 0, 0, 0.14);
}
</style>
